import { useCallback, useState } from 'react';
import {getFunctions, httpsCallableFromURL} from 'firebase/functions';
import { firebaseApp } from "services/DatabaseService";
import Constant from 'utils/Constant';

const usePortalLink = () => {
  const [state, setState] = useState({
    loading: false,
    link: '',
  });

  const openLink = useCallback(async () => {
    setState({loading: true, link: ''});
    const response = await httpsCallableFromURL(
      getFunctions(firebaseApp),
      `https://us-central1-${Constant.firebaseConfig.projectId}.cloudfunctions.net/ext-firestore-stripe-payments-createPortalLink`,
    )({
      returnUrl: window.location.origin
    });
    
    window.location.href = (response.data as {url: string}).url;
  }, []);

  return {
    ...state,
    openLink,
  }
};

export default usePortalLink;
